const ProductSwiper = {
  mainCarousel: null,
  SELECTORS: {
    main: '[data-js-product-swiper-main]',
    thumbs: '[data-js-product-swiper-thumbs]',
    slideVariantId: '[data-variant-id]',
  },
  init() {
    this.initSwiper(document);
  },
  initSwiper(parentElement) {
    const mainSwiperEl = parentElement.querySelector(this.SELECTORS.main);
    const thumbSwiperEl = parentElement.querySelector(this.SELECTORS.thumbs);

    if (mainSwiperEl && thumbSwiperEl) {
      const prevEl = parentElement.querySelector('[data-js-product-swiper-prev]');
      const nextEl = parentElement.querySelector('[data-js-product-swiper-next]');

      const thumbSwiper = new Swiper(thumbSwiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400,
        centerInsufficientSlides: true,
        watchSlidesProgress: true,
        breakpoints: {
          990: {
            direction: 'vertical',
            slidesPerView: 'auto',
            centerInsufficientSlides: false,
          },
        },
      });

      this.mainCarousel = new Swiper(mainSwiperEl, {
        slidesPerView: 1,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400,
        watchOverflow: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        thumbs: {
          swiper: thumbSwiper,
        },
      });

      this.mainCarousel.on('slideChange', (swiper) => {
        swiper.slides.forEach((slide, index) => {
          if (slide.dataset.type === 'video') {
            if (index === swiper.realIndex) {
              slide.querySelector('video').play();
            } else {
              slide.querySelector('video').pause();
              slide.querySelector('video').currentTime = 0;
            }
          }
        });
      });
    }
  },
  slideToVariantImage(variantId) {
    if (!this.mainCarousel) {
      return;
    }

    this.mainCarousel.slides.some((slide, index) => {
      const slideVariantId = slide.getAttribute(this.SELECTORS.slideVariantId.replace('[', '').replace(']', ''));

      if (slideVariantId === variantId) {
        this.mainCarousel.slideTo(index);
      }
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  ProductSwiper.init();
});

document.addEventListener('shopify:section:load', () => {
  ProductSwiper.init();
});

document.addEventListener('shopify:section:reorder', () => {
  ProductSwiper.init();
});

window.ProductSwiper = ProductSwiper;
